// extracted by mini-css-extract-plugin
export default {"customContainer":"AddNewChannels_customContainer__ARYXe"};